import React, { useEffect, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import copy from 'copy-to-clipboard';
const recruiterPanelData = JSON.parse(document.getElementById('job-description-data')?.innerHTML ?? '');
export const JobDescription = () => {
    const [jobListings, setJobListings] = useState(null);
    const [vacancyId, setVacancyId] = useState(null);
    const [vacancy, setVacancy] = useState(null);
    const [vacancyTitle, setVacancyTitle] = useState(null);
    const shareBtn = useRef(null);
    const copyMessage = useRef(null);
    const pageUrl = document.querySelector('meta[property="og:url"]')?.getAttribute('content') + '/vacancy/' + vacancyId;
    function copyMessageHandler() {
        if (copyMessage && copyMessage.current) {
            copyMessage.current.classList.add('is-hidden');
        }
    }
    function shareBtnHandler() {
        if (shareBtn && copyMessage && copyMessage.current) {
            copy(pageUrl);
            copyMessage.current.classList.remove('is-hidden');
        }
    }
    const recruiterPanelInfo = recruiterPanelData.find(entry => entry.email === vacancy?.recruiter.email);
    // Get all vacancies
    useQuery('allJobListings', async () => {
        return fetch(`/api/hatchery/vacancies/`, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
            setJobListings(data.vacancyFeed.vacancy);
        })
            .catch(error => {
            console.error('Error:', error);
        });
    }, { staleTime: Infinity });
    useEffect(() => {
        // Get the current vacancy id
        const jobDescriptionEl = document.getElementById('job-description-component');
        if (jobDescriptionEl) {
            setVacancyId(jobDescriptionEl.dataset.vacancyId);
        }
    }, []);
    useEffect(() => {
        if (shareBtn && shareBtn.current) {
            // Setup shareBtn
            shareBtn.current.addEventListener('click', shareBtnHandler);
            // Remove event listeners on unmount
            return () => {
                if (shareBtn && shareBtn.current) {
                    shareBtn.current.removeEventListener('click', shareBtnHandler);
                }
            };
        }
    }, [shareBtn.current, copyMessage.current]);
    useEffect(() => {
        if (copyMessage && copyMessage.current) {
            // Setup copyMessage
            copyMessage.current.addEventListener('webkitAnimationEnd', copyMessageHandler);
            // Remove event listeners on unmount
            return () => {
                if (copyMessage && copyMessage.current) {
                    copyMessage.current.removeEventListener('webkitAnimationEnd', copyMessageHandler);
                }
            };
        }
    }, [copyMessage.current]);
    // Get the selected vancancy from all vacancies
    useEffect(() => {
        if (jobListings) {
            const selectedVacancy = jobListings.find(key => key.id === vacancyId);
            if (selectedVacancy === undefined) {
                window.location.href = '/404';
            }
            setVacancy(selectedVacancy);
        }
    }, [jobListings]);
    // Split title into headline and subheadline
    useEffect(() => {
        if (vacancy) {
            const titleArray = vacancy.advertText.displayJobTitle.split(' - ');
            setVacancyTitle([titleArray.shift(), titleArray.join(' - ')]);
        }
    }, [vacancy]);
    return (React.createElement("div", null, vacancy && (React.createElement(React.Fragment, null,
        React.createElement("a", { className: 'arrow', href: '/vacancies' },
            React.createElement("img", { height: '14', src: '/assets/dist/images/icon-arrow-back.svg', alt: 'Icon arrow back' })),
        React.createElement("div", { className: 'headline-container' },
            React.createElement("h2", { className: 'headline' }, vacancyTitle && vacancyTitle[0]),
            React.createElement("div", { className: 'lower-row' },
                React.createElement("h2", { className: 'subheadline' }, vacancyTitle && vacancyTitle[1]),
                React.createElement("button", { ref: shareBtn, className: 'btn share-btn', title: 'copy link to clipboard' },
                    React.createElement("div", { className: 'image-wrapper icon-share' },
                        React.createElement("img", { src: '/assets/dist/images/icon-share.svg', alt: 'share icon' }))),
                React.createElement("div", { ref: copyMessage, className: 'copy-message is-hidden' }, "Copied to clipboard"),
                React.createElement("a", { href: 'mailto:?subject=#BePartOfUs: Look at this job opportunity at Mercedes-Benz Customer Assistance Center Maastricht N.V.&body=The Mercedes-Benz Customer Assistance Center in Maastricht is currently looking for motivated, Dutch and international candidates up for a new challenge. #BePartOfUs and have a look at this inspiring position and our attractive relocation package:%0D%0D' +
                        pageUrl, className: 'btn mail-btn', title: 'share via e-mail' },
                    React.createElement("div", { className: 'image-wrapper icon-share' },
                        React.createElement("img", { src: '/assets/dist/images/icon-mail.svg', alt: 'mail icon' }))))),
        React.createElement("p", null,
            React.createElement("a", { className: 'btn is-primary', href: `/vacancy-apply/${vacancyId}` }, "Apply now")),
        React.createElement("div", { className: 'content' },
            React.createElement("div", { className: 'text-block' },
                React.createElement("h2", null, "Recruiter"),
                React.createElement("div", null,
                    recruiterPanelInfo?.photoSrc && (React.createElement("div", { className: 'image-wrapper' },
                        React.createElement("img", { className: 'recruiter-photo', src: recruiterPanelInfo?.photoSrc, srcSet: `${recruiterPanelInfo?.photoSrcSet} 2x`, alt: recruiterPanelInfo?.photoAlt.value ??
                                `Portrait of ${vacancy.recruiter.firstName} ${vacancy.recruiter.lastName}` }))),
                    React.createElement("span", { className: 'recruiter-name' }, vacancy.recruiter.firstName + ' ' + vacancy.recruiter.lastName),
                    React.createElement("br", null),
                    React.createElement("a", { href: `mailto:${vacancy.recruiter.email}` }, vacancy.recruiter.email))),
            React.createElement("div", { className: 'text-block' },
                React.createElement("h2", null, "Company Information"),
                React.createElement("div", { dangerouslySetInnerHTML: {
                        __html: vacancy.advertText.companyInformation,
                    } })),
            React.createElement("div", { className: 'text-block' },
                React.createElement("h2", null, "Function Description"),
                React.createElement("div", { dangerouslySetInnerHTML: {
                        __html: vacancy.advertText.description,
                    } })),
            React.createElement("div", { className: 'text-block' },
                React.createElement("h2", null, "Job Requirements"),
                React.createElement("div", { dangerouslySetInnerHTML: {
                        __html: vacancy.advertText.jobRequirements,
                    } })),
            React.createElement("div", { className: 'text-block' },
                React.createElement("h2", null, "Compensation"),
                React.createElement("div", { dangerouslySetInnerHTML: {
                        __html: vacancy.advertText.compensation,
                    } })),
            React.createElement("div", { className: 'text-block' },
                React.createElement("h2", null, "Contact Info"),
                React.createElement("div", { dangerouslySetInnerHTML: {
                        __html: vacancy.advertText.contactInfo,
                    } })),
            React.createElement("div", { className: 'button-container' },
                React.createElement("a", { className: 'btn is-primary', href: `/vacancy-apply/${vacancyId}` }, "Apply now"),
                React.createElement("a", { className: 'back', href: '/vacancies' }, "back to Vacancies")))))));
};
export default JobDescription;
